import React from 'react';
import { storiesOf } from '@storybook/react';
import { CreateAlertModal } from './CreateAlertModal';

storiesOf('Manage Alerts', module)
  .add('CreateAlertModal', () => (
    <CreateAlertModal show advancedSearch={dataForCreateAlert} onClose={() => null} onSave={() => null} />
  ))
  .add('CreateOrEditAlertModal', () => (
    <CreateAlertModal show advancedSearch={dataForCreateOrEditAlert} onClose={() => null} onSave={() => null} />
  ));

const dataForCreateAlert = {
  alert: {
    data: {
      delivery: null,
      meta: {},
      name: null,
      notify_interval: null,
      notify_interval_label: null,
    },
  },
  filter: {
    template: 'case_lookup',
  },
};

const dataForCreateOrEditAlert = {
  alert: {
    data: {
      delivery_options: ['', 'rss', 'webhook'],
      edit_access: true,
      edit_token: 'b880680666d9c629290cd2bbe89f27a5',
      id: '6862',
      mail_list: ['admin@inforuptcy.com'],
      name: 'edited_alert',
      notify_interval: 86400,
      notify_interval_label: 'Daily',
      resend: false,
      resend_token: 'ea3bfcaa282274cd9fb48dfaaccf59c0',
      type: 'case_lookup',
      type_label: 'Cases',
    },
  },
  filter: {
    template: 'case_lookup',
  },
};



// WEBPACK FOOTER //
// ./src/pages/advancedSearch/Alerts/CreateAlertModal.stories.jsx